export default __webpack_public_path__ + "static/img/vogue_scene_animated_0372.8720ac4.webp";